import { Modal, notification } from "antd";
import Title from "antd/es/typography/Title";
import { useFormikContext } from "formik";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateReportCategoriesMutation } from "shared/api";
import { handleRequestError } from "shared/helpers";
import { Colors } from "shared/themes";
import { FormInput } from "shared/ui";

interface EditReportCategoriesModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const EditReportCategoriesModal: FC<EditReportCategoriesModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();

  const [api, contextHolder] = notification.useNotification();

  const { values, resetForm, handleChange, handleBlur, errors, isValid } =
    useFormikContext<{
      id: number;
      name: string;
    }>();

  const [updateReportCategories] = useUpdateReportCategoriesMutation();

  const closeModal = () => {
    onClose();
    resetForm();
  };

  const handleReportCategoryUpdate = async () => {
    try {
      await updateReportCategories(values).unwrap();

      api.success({
        message: t("reports.success-title"),
        description: t("Report category successfully updated"),
      });
    } catch (error) {
      api.error({
        message: t("reports.error-title"),
        description: handleRequestError(error, t("reports.error")),
      });
    } finally {
      closeModal();
    }
  };

  return (
    <>
      {contextHolder}
      <Modal
        title="Edit Report Categories"
        open={isOpen}
        onCancel={closeModal}
        okButtonProps={{
          disabled: !isValid,
          style: {
            background: `${Colors.blue.primary}`,
          },
        }}
        onOk={handleReportCategoryUpdate}
      >
        <Title level={5} className="text-[14px]">
          Report Category
        </Title>
        <FormInput
          value={values.name}
          fieldName="name"
          placeholder="Enter report category"
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.name}
          isError={!!errors.name}
        />
      </Modal>
    </>
  );
};

export default EditReportCategoriesModal;
